<template>
  <div id="answer">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>培训考试&nbsp;/&nbsp;答题管理</span>
        </div>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
         <el-input class="elinputs" v-model="beginData.uname" placeholder="答题用户"></el-input>
         <el-input class="elinputs" v-model="beginData.uphone" placeholder="手机号"></el-input>
         <el-input class="elinputs" v-model="beginData.uidcard" placeholder="身份证号码"></el-input>
         <!-- <el-input class="elinputs" v-model="beginData.id" placeholder=" 答题编号"></el-input> -->
          <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
          <el-button type="info" @click="resets">重置</el-button>
        </div>
        <div class="tit">
          <Reset @clkBtn='theBtn'></Reset>
          <Xlsx :name="formname"></Xlsx>
        </div>
        <el-table :data="tableData" @selection-change="handleSelectionChange" id="exportTab" border stripe style="width: 100%">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <!-- <el-table-column prop="id" label="答题编号" width="100"></el-table-column> -->
            <el-table-column prop="uname" label="答题用户" width="160"></el-table-column>
            <el-table-column prop="uphone" label="手机号" width="240"></el-table-column>
            <el-table-column prop="uidcard" label="身份证号码" sortable width="240"></el-table-column>
            <el-table-column prop="fraction" label="得分" sortable width="160"></el-table-column>
            <el-table-column prop="answertime" sortable label="答题时间" width="180"></el-table-column>
            <el-table-column label="操作" fixed="right" min-width="180">
                <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(2,scope.row)"><i class="el-icon-edit"></i> 答题详情</el-button>
                <el-button size="mini" type="danger" @click="stop(scope.row,'answer:delete')"><i class="el-icon-delete"></i> 删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="paging">
            <span>
            共
            <i class="pagingNum">{{total}}</i> 条
            </span>
            <Paging :gopage="total" @pag="pag"></Paging>
        </div>
    </el-card>
    <el-dialog title="答题详情查看" :visible.sync="dialogFormVisible" width="60%">
        <el-form>
            <el-form-item label="* 答题用户：">
                <p>{{mydata.uname}}</p>
            </el-form-item>
            <el-form-item label="* 手机号：">
                <p>{{mydata.uphone}}</p>
            </el-form-item>
            <el-form-item label="* 身份证：">
                <p>{{mydata.uidcard}}</p>
            </el-form-item>
            <el-form-item label="* 答题时间：">
                <p>{{mydata.answertime}}</p>
            </el-form-item>
            <el-form-item label="* 答题数：">
                <p class="dtstat">{{mydata.answerNum}}<span>答对数：{{mydata.answerTrueNum}}</span><span>答错数：{{mydata.answerFalseNum}}</span><span>得分：{{mydata.fraction}}</span></p>
            </el-form-item>
            <el-form-item v-for="(item,index) in details" :key="index" label=' '>
                <img :src="item.isTF==1?right:error" alt="" class="staimg">
                <p>{{index+1+'、'+item.title}}</p>
                <p>A：{{item.optionA}}</p>
                <p>B：{{item.optionB}}</p>
                <p v-if="item.optionC!=null">C：{{item.optionC}}</p>
                <p v-if="item.optionD!=null">D：{{item.optionD}}</p>
                <p class="summary"><span>用户答题：<i>{{item.userOption}}</i></span><span>正确答题：<i>{{item.correctOption}}</i></span></p>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">关 闭</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext';
import Reset from "@/components/Reset";
import Paging from '@/components/Paging';
export default {
  name: "answer",
  components: {
    Xlsx,
    EditorBar,
    Reset,
    Paging
  },
  data() {
    return {
      beginData:{},
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      dialogFormVisible: false,
      details:[],
      userdata: {},
      total: 0,
      btn: [],
      fullscreenLoading: true,
      formname:JSON.stringify({name:'答题管理',hint:'answer:export'}),
      sheng:'',
      shi:'',
      shenglist:[],
      shilist:[],
      status:'',
      right:require("../../assets/img/icon_right.png"),
      error:require("../../assets/img/icon_wrong.png"),
      mydata:{},
      multipleSelection:[]
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
  },
  methods: {
    //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            return this.$message('暂无添加功能')
        }else if(i==2){
            if(this.btn.indexOf('answer:update')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            if(this.multipleSelection.length != 1){
                return this.$message('请勾选一项内容查看')
            }
            this.handleEdit(2,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('answer:delete')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.choice()
        }else if(i==4){
            this.query()
        }
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    //   多选删除
    choice(){
        if(this.multipleSelection.length == 0){
            return this.$message('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-e/answer/deleteAnswer/${arr.join(',')}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    resets(){
        this.$router.push('/refresh')
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin();
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        id:this.beginData.id,
        uidcard:this.beginData.uidcard,
        isshow:this.beginData.isshow,
        uname:this.beginData.uname,
        uphone:this.beginData.uphone,
        areasid: userdata.areasId
      });
      this.$axios.post(`/api-e/answer/answerLists`, data, {headers: { accessToken: userdata.token }})
        .then(res => {
            this.fullscreenLoading = false;
            if(res.data.success){
            // this.$set(this, "tableData", res.data.pageInfo.list);
              this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                  this.$set(this, "tableData", res.data.pageInfo.list);
              });
              this.$set(this, "total", res.data.pageInfo.total);
              this.$message({
                  type: 'success',
                  message: res.data.msg
              });
            }else{
              this.$message(res.data.msg)
            }
        });
    },
    handleEdit(i,row) {
        this.status = i
        if(i == 2){
            this.$axios.post(`/api-e/answer/getAnswer/${row.id}`,{},{ headers: { accessToken: this.userdata.token } })
            .then(res => {
                this.details = res.data.answerInfos
                this.mydata = res.data
                this.dialogFormVisible = true;
            });
        }
    //   this.$set(this, "information", i);
    },
    stop(row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
      this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let url = ``
          url = `/api-e/answer/deleteAnswer/${row.id}`
          this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  this.begin();
              }else{
                  alert(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    }
  }
};
</script>
<style>
.w-e-toolbar{
  flex-wrap: wrap;
}
#answer .el-input__inner {
  margin: 10px 0;
}
#answer .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#answer .el-menu-item.is-active{
  background: none
}
#answer .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#answer .el-tag{
  margin-right: 12px;
}
#answer .el-select {
  /* margin: 0 8px; */
}
#answer .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#answer .el-upload-list--picture .el-upload-list__item {
    width: 44%;
    float: left;
    margin-right: 2%;
}
#answer .el-form-item__content {
    width: 100%;
}
#answer .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#answer .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#answer .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#answer .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#answer .el-dialog__body {
  height: 382px;
}
#nei .el-dialog__body{
  height: 150px !important;
}
#answer .el-form-item{
    display: flex;
    /* align-items: center; */
    margin-bottom:0
}
#answer .el-form-item__label{
    width: 122px
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
.summary>span:first-child{
    margin-right: 20px
}
.summary>span:first-child i{
    color:red
}
.summary>span:last-child i{
    color:green
}
.staimg{
    position: absolute;
    left: -26px;
    top: 10px;
    width: 18px;
}
.dtstat span{
    margin: 0 34px;
}
</style>
